const convertoformdata = (obj) => {
  const formData = new FormData();
  for (const key in obj) {
    const value = obj[key];
    
    // Skip null/undefined values
    if (value === null || value === undefined) {
      continue;
    }
    
    // Handle File objects
    if (value instanceof File) {
      formData.append(key, value);
      continue;
    }
    
    // Handle arrays - JSON stringify them so backend can parse properly
    if (Array.isArray(value)) {
      formData.append(key, JSON.stringify(value));
      continue;
    }
    
    // Handle plain values
    formData.append(key, value);
  }
  return formData;
};

export default convertoformdata;